import React, { useState, useEffect, useCallback } from "react";
import MenuButton from "../../components/common/menuButton/MenuButton";
import { Grid } from "@mui/material";
import { AutoStoriesIcon } from "../../shared/components/icon";
import { useDialog, useAuth } from "../../shared/context";
import ViewedDocumentsDialog from "../../components/Dialog/ViewedDocumentsDialog";
import AxiosInstance from "../../server/AxioInstance";

const GenericDialog = ({
  handleClose,
  handleConfirm,
  handleCancel,
  dialogData,
  ContentComponent,
}) => (
  <div>
    <ContentComponent
      handleClose={handleClose}
      handleConfirm={handleConfirm}
      handleCancel={handleCancel}
      dialogData={dialogData}
    />
  </div>
);

// Array de botões
const buttons = [
  {
    title: "Documentos Visualizados",
    icon: <AutoStoriesIcon color="primary" sx={{ fontSize: "10em" }} />,
    modal: "showViewedDocumentsDialog",
    ContentComponent: ViewedDocumentsDialog,
  },
];

const Home = () => {
  const [currentDialog, setCurrentDialog] = useState("showViewedDocumentsDialog");
  const [background, setBackground] = useState(false);
  const [row, setRow] = useState([]);
  const { isDialogOpen, openDialog, closeDialog } = useDialog(currentDialog);
  const { checkTokenValidity } = useAuth();

  const handleOpenModal = (button) => {
    openDialog();
    setCurrentDialog(button.modal);
  };

  const handleConfirmAction = () => {
    closeDialog();
  };

  const handleCancelAction = () => {
    closeDialog();
  };

  const GetDataDocumentView = useCallback(async () => {
      const result = await AxiosInstance.get(
        "/home/document-view?user=" + localStorage.getItem("@gedy:user")
      );
      setBackground(result.data.review)
      setRow(result.data.data);
    
  }, []);

  useEffect(() => {
    if (currentDialog) {
      openDialog(row);
    }
    checkTokenValidity();
    GetDataDocumentView();
    closeDialog();

    // eslint-disable-next-line
  }, [currentDialog, GetDataDocumentView]);

  return (
    <>
      {isDialogOpen() && (
        <GenericDialog
          handleClose={closeDialog}
          handleConfirm={handleConfirmAction}
          handleCancel={handleCancelAction}
          dialogData={row}
          ContentComponent={
            buttons.find((button) => button.modal === currentDialog)
              ?.ContentComponent
          }
        />
      )}

      <Grid
        container
        spacing={2}
        justifyContent="space-around"
        alignItems="center"
      >
        {buttons.map((button) => (
          <Grid item key={button.title} xs={12} sm={6} md={4}>
            <MenuButton
              title={button.title}
              icon={button.icon}
              onClick={() => handleOpenModal(button)}
              backgroundColor={background ? '#FFCCCC' : '#FFF'}
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default Home;
